module.exports = __webpack_public_path__ + "img/fund.a1b9b281.svg";